import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { constants } from '@app/shared/utils/constants';

@Pipe({
  name: 'difficulty',
  standalone: false,
})
export class DifficultyPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    if (!value) {
      return null;
    }

    return constants.ticketcenter.difficulties.find(tlt => tlt.value === value).label;
  }
}
